var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58606 12.3052H2.31543C1.98391 12.3052 1.66597 12.1735 1.43155 11.9391C1.19713 11.7046 1.06543 11.3867 1.06543 11.0552V3.55518C1.06543 3.22366 1.19713 2.90571 1.43155 2.67129C1.66597 2.43687 1.98391 2.30518 2.31543 2.30518H6.21427M6.93481 11.2363V12.4656C6.93481 12.8459 7.06651 13.1043 7.30093 13.3348C7.53535 13.5654 7.85329 13.6949 8.18481 13.6949H13.6848C14.0163 13.6949 14.3343 13.5654 14.5687 13.3348C14.8031 13.1043 14.9348 12.7916 14.9348 12.4656V5.08967C14.9348 4.76363 14.8031 4.45095 14.5687 4.22041C14.3343 3.98987 14.0163 3.86035 13.6848 3.86035H8.18481C7.85329 3.86035 7.53535 3.98987 7.30093 4.22041C7.06651 4.45095 6.93481 4.76363 6.93481 5.08967V6.31898M10.6399 6.27765L13.1399 8.77765L10.6399 11.2776M3.63989 7.27765C3.63989 7.27765 4.63989 8.77765 6.88989 8.77765C9.13989 8.77765 12.6399 8.77765 12.6399 8.77765",
    stroke: "#505762",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.8165d86c4e6fe75495fcf56d3fd57a8f.svg";
export { ForwardRef as ReactComponent };